import React from "react";
import { Button, Input, UncontrolledTooltip, Alert, Col, FormGroup } from "reactstrap";
import LessonCard from "../LessonCard";
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import SectionCollapsable from '../AuthorCollapsable/SectionCollapsable'
import { PulseLoader } from 'react-spinners'
import { connect } from 'react-redux'
import {forOwn, find} from 'mout/object'
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText';
import { courses } from '../../../../redux/actions/courses'
import arrayMove from 'array-move'

const SortableItem = sortableElement(({ value, toggle, subIndex, toggleCards, toggleCard, index, addSection, lastItem, reArrangeSection, sectionToggle, onSortEnd, updateSectionIndex }) => <li><SectionCollapsable updateSectionIndex={updateSectionIndex} onSortEnd={onSortEnd} sectionToggle={sectionToggle} reArrangeSection={reArrangeSection} lastItem={lastItem} index={index} addSection={addSection} toggleCard={toggleCard} toggleCards={toggleCards} toggle={toggle} subIndex={subIndex} value={value} /></li>);

const SortableContainer = sortableContainer(({ children }) => {
    return <ul style={{ listStyle: 'none' }}>{children}</ul>;
});

class ManageSubcourse extends React.Component {
  state = {
    
   items : [],
   reArrangeSection: false,
   diff: [],
   toggle: false,
   toggleValue : '',
   addSection: false
  }

  componentDidMount(){
    //replace the function wiht getSubcourse
    this.props.getCourseSubcourses('bc902bb0-50d2-11e9-a87c-65047176e447')
    this.props.getSection('ef223ab0-5649-11e9-958b-a7194ee37ab0')
  }

  componentDidUpdate(prevProps) {
    if (this.props.courses.subcourseSections['ef223ab0-5649-11e9-958b-a7194ee37ab0'] && this.state.items.length === 0) {
      const { courses, value } = this.props

      let sections = courses.subcourseSections['ef223ab0-5649-11e9-958b-a7194ee37ab0']
      let subcourse = find(courses.subcourses, {'id' : 'ef223ab0-5649-11e9-958b-a7194ee37ab0'})
      let items = []
      forOwn(subcourse.sections, function (val, key) {
          sections.forEach(section => {

              if (section.id === key) {
                  let obj = {
                      ...section,
                      index: val
                  }
                  items.push(obj);
              }
          })
      })
      this.setState({ items: sortByPropText(items, 'index') })
  }
  }

  toggleCards = value => {
    this.setState(state => ({ toggleValue: value, toggle: !state.toggle }));
  };

  updateSectionIndex = (id, index) => {
    this.setState(state => {
        let arr = Array.from(state.diff)
        arr.push({ id, index })
        return { diff: arr }
    })
  }


  onSortEnd = ({ oldIndex, newIndex }) => {
      this.setState(({ items }) => ({
          items: arrayMove(items, oldIndex, newIndex),
      }));
      // if (this.state.diff.length > 0) {
      //     this.props.updateIndexSection(this.props.value.id, this.state.diff)
      //     this.setState({ diff: [] })
      // }
  };

  toggleSection = () => {
    this.setState(state => ({reArrangeSection : !state.reArrangeSection}))
  }
  addSection = () => {
    this.setState({addSection: !this.state.addSection})
  }

  render() {
    const { items, reArrangeSection, addSection } = this.state

    return (
      <LessonCard  
      iconClass="lesson-book"
      heading="View and Manage Sections & Lessons"
      isCollapsable
      headerButtons={[
        <Button className='icon-btn'><i className='icon-preview-icon'></i></Button>,
    ]}>
      <div className='filter-input'>
          <Input onChange={e => this.itemsFilter(e, 'itemTableData')} type="text" name="filter-input" placeholder='Search' />
      </div>

      <div className="course-sortable-container author-course-edit">
      <div className="course-list-items">
      <div className={`draggable-row  mt-3`}>
      <span className="draggable-row-text text-subcourse mr-1">ACT Mastery English</span>
                    <span onClick={this.toggleSection} id={`tool-1-rearrange`} className={`${reArrangeSection ? 'active' : ''}' rearrange-icon draggable-title-icons mx-1`}></span>
                    <i id={`tooltip-1-new`} onClick={this.addSection} className="draggable-title-icons mx-1 add-contents-icon" />
                    <UncontrolledTooltip target={`tool-1-rearrange`} >Rearrange Sections</UncontrolledTooltip>
                    <UncontrolledTooltip target={`tooltip-1-new`} >Add New Section</UncontrolledTooltip>
                 
                    
                </div>
              
                        <SortableContainer helperClass={'draggable-helper'} lockAxis={'y'} useDragHandle shouldCancelStart={this.shouldCancelStart} distance={1} onSortEnd={this.onSortEnd}>
                                {
                                    (items.length === 0) && (<Alert
                                        color="danger"
                                    >{`No Sections Added, you can add a new section below.`}</Alert>)
                                }



                                {items.length > 0 && items.map((value, index) => (
                                    <SortableItem updateSectionIndex={this.updateSectionIndex} onSortEnd={this.onSortEnd} reArrangeSection={reArrangeSection} sectionToggle={false} addSection={false} toggleCard={this.state.toggleValue} lastItem={items.length} toggleCards={this.toggleCards} toggle={this.state.toggle} subIndex={0} key={`item-${index}`} index={index} value={value} />
                                ))}
                                {(addSection || (items.length === 0)) && <Col xs={12} md={4} className="new-item-section scroll-to-section">
                                    <Col className="p-0 subcourse-head">Add new Section</Col>
                                    <FormGroup row>
                                        <Col sm="9"><Input value={this.state.name} onChange={this.handleChange} placeholder={'Enter Section Name ..'} /></Col>
                                        <Col sm="3" className="pl-0">
                                            <Button onClick={this.submit} disabled={this.state.name === ''} className="w-100">{courses.creatingSection ? <div className="m-auto"><PulseLoader loading color={'#fff'} size={10} /></div> : 'Save'}</Button>
                                        </Col>
                                    </FormGroup>
                                </Col>}
                            </SortableContainer>
          
                          

                            </div>
      </div>  


      </LessonCard>
    );
  }
}



const mapStateToProps = state => {
  return {
      courses : state.courses
  }
}

const mapDispatchToProps = dispatch => {
  return {
      getSection: (subcourseId) => { dispatch(courses.getSection(subcourseId)) },
      getCourseSubcourses: (courseId) => { dispatch(courses.getCourseSubcourses(courseId)) },
      createSubcourse: (subcourse, course) => { dispatch(courses.createSubcourse(subcourse, course)) },
  }
}


export default connect(mapStateToProps,mapDispatchToProps)(ManageSubcourse)


// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorSubcourseCards/ManageSubcourse.js